import { render, staticRenderFns } from "./UserInfoPopover.vue?vue&type=template&id=75abf54a&scoped=true"
import script from "./UserInfoPopover.vue?vue&type=script&lang=ts"
export * from "./UserInfoPopover.vue?vue&type=script&lang=ts"
import style0 from "./UserInfoPopover.vue?vue&type=style&index=0&id=75abf54a&prod&lang=less&scoped=true"
import style1 from "./UserInfoPopover.vue?vue&type=style&index=1&id=75abf54a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75abf54a",
  null
  
)

export default component.exports